<template>
  <a-drawer
    :title="title"
    width="60%"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="hide"
  >
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="分配信息" :column="2" bordered>
          <a-descriptions-item label="分配单号">{{ detailData.allocationNo || '-' }}</a-descriptions-item>
          <a-descriptions-item label="分配记录ID">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="接收方代理ID">{{ detailData.agentTenantId || '-' }}</a-descriptions-item>
          <a-descriptions-item label="企业自有池ID">{{ detailData.enterpriseOwnPoolId || '-' }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '-' }}</a-descriptions-item>
          <a-descriptions-item label="过期时间">{{ formatTime(detailData.expireTime) || '-' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="容量信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="分配总容量">
            <span class="capacity-text">{{ $formatCapacity(detailData.allocateCapacity) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="剩余容量">
            <span class="capacity-text">{{ $formatCapacity(detailData.remainingCapacity) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="已使用容量">
            <span class="capacity-text">{{ $formatCapacity(detailData.usedCapacity) }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="使用率">
            <span class="usage-text">{{ getUsageRate() }}%</span>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="状态信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="状态">
            <a-tag :color="getStatusColor(detailData.status)">
              {{ getStatusText(detailData.status) }}
            </a-tag>
          </a-descriptions-item>

        </a-descriptions>

        <!-- 扩展信息 -->
        <a-descriptions title="扩展信息" :column="2" bordered style="margin-top: 16px" v-if="hasExtendInfo">
          <a-descriptions-item label="扩展日期1" v-if="detailData.extendD1">
            {{ formatTime(detailData.extendD1) }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展日期2" v-if="detailData.extendD2">
            {{ formatTime(detailData.extendD2) }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展数值1" v-if="detailData.extendI1">
            {{ detailData.extendI1 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展数值2" v-if="detailData.extendI2">
            {{ detailData.extendI2 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展字段1" v-if="detailData.extendS1">
            {{ detailData.extendS1 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展字段2" v-if="detailData.extendS2">
            {{ detailData.extendS2 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展字段3" v-if="detailData.extendS3">
            {{ detailData.extendS3 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展字段4" v-if="detailData.extendS4">
            {{ detailData.extendS4 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展字段5" v-if="detailData.extendS5">
            {{ detailData.extendS5 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展字段6" v-if="detailData.extendS6">
            {{ detailData.extendS6 }}
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="备注信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="备注">{{ detailData.remark || '无备注' }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getDetail } from '@/api/VR/assignAgents'
import { message } from 'ant-design-vue'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
      statusMap: {
        1: '有效',
        2: '已过期',
        3: '已用完',
        4: '已回收',
      },
      statusColorMap: {
        1: 'green',
        2: 'orange',
        3: 'blue',
        4: 'red',
      },
      expireDeductStatusMap: {
        0: '未执行',
        1: '已执行',
      },
      expireDeductStatusColorMap: {
        0: 'orange',
        1: 'green',
      },
    }
  },
  computed: {
    title() {
      return `分配记录详情`
    },
    hasExtendInfo() {
      return this.detailData.extendD1 || this.detailData.extendD2 ||
             this.detailData.extendI1 || this.detailData.extendI2 ||
             this.detailData.extendS1 || this.detailData.extendS2 ||
             this.detailData.extendS3 || this.detailData.extendS4 ||
             this.detailData.extendS5 || this.detailData.extendS6
    },
  },
  methods: {
    show(record) {
      this.visible = true
      this.loadDetail(record.id)
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getDetail({ id })
        if (response && response.data) {
          this.detailData = response.data
        } else {
          message.error('获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
     formatCapacity(capacity) {
      if (!capacity && capacity !== 0) return '0G'

      const totalMB = capacity

      if (totalMB < 1024) {
        return `${totalMB}M`
      }

      const gb = Math.floor(totalMB / 1024)
      const mb = totalMB % 1024

      if (mb === 0) {
        return `${gb}G`
      }

      return `${gb}G.${mb}M`
    },
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
    getUsageRate() {
      const { allocateCapacity, usedCapacity } = this.detailData
      if (!allocateCapacity || allocateCapacity === 0) return 0
      const rate = ((usedCapacity || 0) / allocateCapacity) * 100
      return Math.min(100, Math.max(0, rate.toFixed(1)))
    },
    getStatusText(status) {
      return this.statusMap[status] || '-'
    },
    getStatusColor(status) {
      return this.statusColorMap[status] || 'default'
    },
    getExpireDeductStatusText(status) {
      return this.expireDeductStatusMap[status] || '-'
    },
    getExpireDeductStatusColor(status) {
      return this.expireDeductStatusColorMap[status] || 'default'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.capacity-text {
  font-weight: 600;
  color: #1890ff;
}

.usage-text {
  font-weight: 600;
  color: #52c41a;
}

.ant-descriptions {
  margin-bottom: 0;
}

.ant-card {
  margin-bottom: 16px;
}

.ant-card:last-child {
  margin-bottom: 0;
}
</style>
